/** * 分页组件 */
<template>
  <el-pagination
    :current-page="childMsg.currentPage"
    :page-size="childMsg.pageSize"
    :total="childMsg.total"
    background
    class="page-box"
    layout="total, slot, prev, pager, next, jumper"
    @current-change="handleCurrentChange"
  >
    <span class="page-size-input">
      <span class="label">每页</span>
      <el-input-number
        :value="childMsg.pageSize"
        :min="1"
        :max="100000"
        :step="10"
        size="small"
        controls-position="right"
        class="size-input"
        @change="handleSizeChange"
      />
      <span class="label">条</span>
    </span>
  </el-pagination>
</template>
<script>
  export default {
    name: "Pagination",
    props: ["childMsg"],
    data() {
      return {
        pageparm: {
          currentPage: this.childMsg.currentPage,
          pageSize: this.childMsg.pageSize
        }
      };
    },
    created() {},
    methods: {
      handleSizeChange(val) {
        /**
         * 子传父
         * 参数1 父元素方法
         * 参数2 数据
         */
        this.pageparm.pageSize = val;
        this.pageparm.currentPage = 1;
        this.$emit("callFather", this.pageparm);
      },
      handleCurrentChange(val) {
        /**
         * 子传父
         * 参数1 父元素方法
         * 参数2 数据
         */
        this.pageparm.currentPage = val;
        this.$emit("callFather", this.pageparm);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .page-box {
    margin: 10px auto;
    text-align: center;
  }
  .page-size-input {
    display: inline-flex;
    align-items: center;
    margin: 0 5px;
    font-size: 13px;
    color: #606266;
    .label {
      margin: 0 4px;
    }
    .size-input {
      width: 100px;
    }
  }
</style>
